import { useState, useEffect } from 'react';

/**
 * @deprecated This should be replaced with a backend type
 */
export type Photo = {
  file: File;
  displayedBlob: Blob;
};

export const usePhotoObjectURL = (photo: Photo | undefined) => {
  const [photoURL, setPhotoURL] = useState<string>();

  useEffect(() => {
    if (photo && photo.file && !photoURL) {
      setPhotoURL(URL.createObjectURL(photo.displayedBlob));
    }

    return () => {
      if (photoURL) {
        URL.revokeObjectURL(photoURL);
      }
    };
  }, [photo, photoURL]);

  return photoURL;
};
